/**
 * EXALLAXE · Manifesto · Régua Lateral
 * Scroll spy: detecta o pensador mais próximo do centro da viewport e aplica .is-active.
 * Clique no dot: scroll suave nativo (href="#id") + blur() para evitar :focus-visible persistente.
 * Throttle via requestAnimationFrame para evitar render artifacts ("fragmentos" de labels).
 */
(function() {
  'use strict';

  const dots = Array.from(document.querySelectorAll('.manifesto-regua-lateral__dot'));
  const quadros = Array.from(document.querySelectorAll('.manifesto-galeria__quadro'));

  if (dots.length === 0 || quadros.length === 0) return;

  // Blur após click para evitar label preso por :focus-visible
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      requestAnimationFrame(() => dot.blur());
    });
    dot.addEventListener('mouseleave', () => dot.blur());
  });

  // Scroll spy throttled com rAF
  let scrollPending = false;

  function atualizarAtivo() {
    if (window.innerWidth <= 900) return;
    if (scrollPending) return;
    scrollPending = true;

    requestAnimationFrame(() => {
      const viewportMid = window.innerHeight / 2;
      let closest = null;
      let closestDist = Infinity;

      quadros.forEach(q => {
        const rect = q.getBoundingClientRect();
        const mid = rect.top + rect.height / 2;
        const dist = Math.abs(mid - viewportMid);
        if (dist < closestDist) {
          closestDist = dist;
          closest = q.id.replace('pensador-', '');
        }
      });

      dots.forEach(d => {
        d.classList.toggle('is-active', d.dataset.target === closest);
      });

      scrollPending = false;
    });
  }

  function init() {
    atualizarAtivo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', atualizarAtivo, { passive: true });
  window.addEventListener('resize', atualizarAtivo, { passive: true });
  document.addEventListener('shopify:section:load', atualizarAtivo);
})();
